import { createFloorPlanPath } from 'helpers/globals'
import axios from 'api/config'

/** Called when creating a Floor Plan */
export function createFloorPlan(params) {
  return axios
    .post(createFloorPlanPath, params, { timeout: 58000, 'axios-retry': { retries: 1 } })
    .then(r => r.data)
}



// WEBPACK FOOTER //
// ./src/api/floorPlanUploads.js